import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionGuard } from '@guard/subscription.guard';
import { Role } from '@interfaces/user';
import { AuthGuard } from './guard/auth.guard';

const routes: Routes = [
  {
    path: 'search',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.User, Role.Admin] },
    loadChildren: () => import('./pages/search/search.module').then((m) => m.SearchHomeModule),
  },
  {
    path: 'search/results/:id',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.User, Role.Admin] },
    loadChildren: () =>
      import('./pages/search/search-results/search-results.module').then((m) => m.SearchResultsModule),
  },
  {
    path: 'spaces',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.User, Role.Admin] },
    loadChildren: () => import('./pages/spaces/spaces.module').then((m) => m.SpacesModule),
  },
  {
    path: 'spaces/:id',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.User, Role.Admin] },
    loadChildren: () => import('./pages/spaces/space-detail/space-details.module').then((m) => m.SpaceDetailsModule),
  },
  {
    path: 'my-apps',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.User, Role.Admin] },
    loadChildren: () => import('./pages/my-apps/my-apps.module').then((m) => m.MyAppsModule),
  },
  {
    path: 'my-account',
    canActivate: [AuthGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin, Role.User] },
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'workspace',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/workspace/workspace.module').then((m) => m.WorkspaceModule),
  },
  {
    path: 'agents',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/agents/agents.module').then((m) => m.AgentsModule),
  },
  {
    path: 'agents/new',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/agents/agent-builder/agent-builder.module').then((m) => m.AgentBuilderModule),
  },
  {
    path: 'agents/:uuid/edit',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/agents/agent-builder/agent-builder.module').then((m) => m.AgentBuilderModule),
  },
  /*{
    path: 'workspace/apps',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/workspace/manage-apps/manage-apps.module').then((m) => m.ManageAppsModule),
  },
  {
    path: 'workspace/members',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () => import('./pages/workspace/users/manage-users.module').then((m) => m.ManageUsersModule),
  },*/
  {
    path: 'workspace/members/:id',
    canActivate: [AuthGuard, SubscriptionGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    loadChildren: () =>
      import('./pages/workspace/users/user-details/manage-user-details.module').then((m) => m.ManageUserDetailsModule),
  },
  /*{
    path: 'workspace/settings',
    data: { roles: [Role.ClientAdmin, Role.Admin] },
    canActivate: [AuthGuard, SubscriptionGuard],
    loadChildren: () => import('./pages/workspace/settings/settings.module').then((m) => m.SettingsModule),
  },*/
  {
    path: 'workspace/billing',
    canActivate: [AuthGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin, Role.User] },
    loadChildren: () => import('./pages/workspace/billing/subscription.module').then((m) => m.SubscriptionModule),
  },
  {
    path: 'workspace/pricing-plans',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/workspace/pricing-plans/pricing-plans.module').then((m) => m.PricingPlansModule),
  },
  {
    path: 'subscription-item-details/:id',
    canActivate: [AuthGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin, Role.User] },
    loadChildren: () =>
      import('./pages/workspace/billing/subscription-item-details/subscription-item-details.module').then(
        (m) => m.SubscriptionDetailsModule,
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'errors',
    loadChildren: () => import('./pages/error-pages/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    data: { roles: [Role.ClientAdmin, Role.Admin, Role.User] },
    loadChildren: () => import('./pages/onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  { path: '**', redirectTo: 'spaces' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
